import { useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'

import AuthBase from '../../../common/components/Auth/AuthBase'
import ConfirmPasswordInput from '../../../common/components/Auth/ConfirmPasswordInput'
import PasswordInput from '../../../common/components/Auth/PasswordInput'
import Button from '../../../common/components/Button'
import styles from './SetNewPassword.module.css'
import ActivationCodeInput from '../../../common/components/Auth/ActivationCodeInput'
import { confirmPasswordReset } from '../../../common/utils/cognito'
import { t } from 'i18next'

type FormData = {
  newPassword: string
  confirmPassword: string
  code: string
}

const SetNewPasswordPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>()
  const [errorMessages, setErrorMessages] = useState<string>()

  const navigate = useNavigate()
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const username = params.get('username')

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    if (!username) {
      return
    }

    const { code, newPassword } = data

    try {
      await confirmPasswordReset(
        decodeURIComponent(username),
        newPassword,
        code,
      )
      navigate('/set-new-password-success')
    } catch (error) {
      setErrorMessages(t('profile.resetPasswordError'))
    }
  }

  return (
    <AuthBase hasBackButton>
      {errorMessages ? (
        <p className={styles.formSubtitle}>{errorMessages}</p>
      ) : (
        <p className={styles.formLabel}>{t('profile.setPassword')}</p>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className={styles.formContainer}>
        <div>
          <PasswordInput
            register={register}
            errors={errors}
            name="newPassword"
            label={t('profile.newPassword')}
          />
          <ConfirmPasswordInput
            register={register}
            errors={errors}
            name="confirmPassword"
            label={t('profile.confirmPassword')}
          />
          <ActivationCodeInput register={register} errors={errors} />
        </div>
        <div>
          <Button title={t('profile.setPassword')} />
        </div>
      </form>
    </AuthBase>
  )
}

export default SetNewPasswordPage
